import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../redux/initialStoreState";
import { useDispatchWrapper } from "./useDispatch";
import {
  clearCommAutomobileGaragePlatesState,
  fetchCommAutomobileGaragePlatesListAsync,
} from "../redux/commAutoPolicy/commAutoGaragePlates/commAutoGaragePlatesActions";

export const useCommAutoGaragePlatesList = (
  customerPolicyId?: string | number | null
) => {
  const { data: garagePlatesList, loading: garagePlatesListLoading } =
    useSelector((storeState: IStoreState) => storeState.commAuto.garagePlate);
  const dispatch = useDispatchWrapper();

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(
        fetchCommAutomobileGaragePlatesListAsync(
          customerPolicyId as number,
          "ACTIVE"
        )
      );
    }
    return () => {
      dispatch(clearCommAutomobileGaragePlatesState());
    };
  }, [customerPolicyId]);

  return {
    garagePlatesList,
    garagePlatesListLoading,
  };
};
